import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Demo } from './Demo';
import AboutB from './AboutB';
import TermsCondition from './TermsCondition';
import Panel from './Panel';
import InfoCards from './InfoCards';
import HelpActionCreator from '../../actions/HelpActionCreator';
import SiteHeaderActionCreator from '../../actions/SiteHeaderActionCreator';
import HelpStore from '../../stores/HelpStore';
import PatternLibModalComponent from '../common/modals/PatternLibModalComponent';
import { RequiresAuthenticatedUser } from '../RequiresAuthenticatedUser';
import AnalyticsUtil from '../../utils/AnalyticsUtil';
import config from '../../config/index';
import Helmet from 'react-helmet';
import EgainUtils from '../../utils/EgainUtils';
import { sayLandingMessage } from '../../actions/AccessibilityActionCreator';
import InternetBankingActions from '../../actions/InternetBankingActions';
import envConfig from '../../../static/config';
import UserManagementStore from '../../stores/UserManagementStore';
import NonBCustomerError from '../common/NonBCustomerError';
import UserManagementActionCreator from '../../actions/UserManagementActionCreator';
import EgainStore from '../../stores/EgainStore';
import EgainActionCreator from '../../actions/EgainActionCreator';
import { getChat } from '../../egainChat/eGainChat';
import { getSMEChat } from '../../egainChat/eGainChatSME';
import { isBOrVMRetail, isVMBusiness } from '../../utils/BrandUtils';
import { BioCatchContext } from '../BioCatchContext';
import { HELP_CONTEXT } from '../../config/BioCatch';
import { NavigationButton } from 'web-ui-components/lib/navigation/buttons';
import StringConstants from '../../constants/StringConstants';
import { GenericModal } from 'web-ui-components/lib/layout/content';
import NavigateToWebApps from '../../utils/NavigateToWebApps';

let TalkHeader;
let EmailHeader;
let LostCardHeader;
let stolenCardContent;
let callCardContent;
let faqURL;
// you can change the div or any html element here.
let callContent;
let TalkContent;
let EmailContent;
let LostCardContent;
let feedbackHeader;
let feedbackContent;
let financialServices;
let TCData = '';
let termsCondition;
let authorisedUserTerm;
let chatContent;
let businessLostCardContent;
let yourSupportHeader;
let yourSupportContent;

const ANY_QUESTION = 'ANY_QUESTION';
const CHAT = 'CHAT';
const CALL_CONTENT = 'CALL_CONTENT';
const SECURE_MESSAGE = 'SECURE_MESSAGE';
const ABOUT_B = 'ABOUT_B';
const TERMS_AND_CONDITIONS = 'TERMS_AND_CONDITIONS';
const FINANCIAL_SERVICES = 'FINANCIAL_SERVICES';
const DEMO = 'DEMO';

class HelpHomeComponent extends Component {
  constructor(props) {
    super(props);
    this.getInfoCards = this.getInfoCards.bind(this);
    this.decideContent = this.decideContent.bind(this);
    this.state = {
      show: true,
      component: ANY_QUESTION,
      showModal: false,
      showChatModal: false,
      saml: '',
      egainChat: UserManagementStore.isSMEUser() ? getSMEChat() : getChat(),
    };
    this.getComponent = this.getComponent.bind(this);
    this.closed = this.closed.bind(this);
    this.initializeStaticContent = this.initializeStaticContent.bind(this);
    this.continue = this.continue.bind(this);
    this.modalFooter = this.modalFooter.bind(this);
    this.getModalBody = this.getModalBody.bind(this);
    this.getModalHeading = this.getModalHeading.bind(this);
    this.onHideChatModal = this.onHideChatModal.bind(this);
    this.initialiseCobrowse = this.initialiseCobrowse.bind(this);
    this.getInfoCardsData = this.getInfoCardsData.bind(this);
    this.retryButton = this.retryButton.bind(this);
    this.onChatClick = this.onChatClick.bind(this);
    this.onStoreChange = this.onStoreChange.bind(this);
  }

  componentWillMount() {
    this.initializeStaticContent();
    HelpActionCreator.getTcData();
    HelpStore.addChangeListener(this.onStoreChange);
    this.state.show
      ? SiteHeaderActionCreator.setSideBarFlag(true)
      : SiteHeaderActionCreator.setSideBarFlag(false);
  }

  componentDidMount() {
    EgainStore.addChangeListener(this.onStoreChange);
    AnalyticsUtil.analyticAction(
      config.analytics.analytics_experience_view,
      config.analytics.analytics_event_method_appeared,
      'PageLoaded'
    );
    sayLandingMessage('Help');
  }

  componentWillUpdate(nextProps, nextState) {
    nextState.show
      ? SiteHeaderActionCreator.setSideBarFlag(true)
      : SiteHeaderActionCreator.setSideBarFlag(false);
  }

  componentWillUnmount() {
    SiteHeaderActionCreator.setSideBarFlag(false);
    HelpStore.removeChangeListener(this.onStoreChange);
    EgainStore.removeChangeListener(this.onStoreChange);
  }

  onChatClick() {
    try {
      window.Microsoft.Omnichannel.LiveChatWidget.SDK.startChat();
    } catch (error) {
      window.dtrum?.reportError(error);
    }
    this.onHideChatModal();
  }

  onStoreChange() {
    const token = EgainStore.getSamlToken();
    if (this.state.saml !== token) {
      this.setState({
        saml: token,
      });
    }
    if (HelpStore.getShowTC()) {
      TCData = HelpStore.getAll();
    }
  }

  getComponent() {
    switch (this.state.component) {
      case ANY_QUESTION:
        faqURL = !UserManagementStore.isSMEUser()
          ? this.props.content.anyQuestionURL
          : this.props.content.anyQuestionBusinessURL;
        HelpActionCreator.backSetUrl('WEB-OPEN-HELP', faqURL);
        InternetBankingActions.navigateToWebTask('WEB-OPEN-FAQ');
        break;
      case DEMO:
        return (
          <div className="">
            <Demo {...this.props} closed={this.closed} />
          </div>
        );

      case ABOUT_B:
        return (
          <div className="">
            <AboutB {...this.props} closed={this.closed}>
              <Panel
                panelHeading={[TalkHeader, EmailHeader, LostCardHeader]}
                panelBody={[TalkContent, EmailContent, LostCardContent]}
              />
            </AboutB>
          </div>
        );

      case TERMS_AND_CONDITIONS:
        return (
          <div className="">
            <TermsCondition
              TCData={TCData}
              {...this.props}
              closed={this.closed}
            >
              <Panel
                panelHeading={[TalkHeader, EmailHeader, LostCardHeader]}
                panelBody={[TalkContent, EmailContent, LostCardContent]}
              />
            </TermsCondition>
          </div>
        );

      default:
        faqURL = !UserManagementStore.isSMEUser()
          ? this.props.content.anyQuestionURL
          : this.props.content.anyQuestionBusinessURL;
        HelpActionCreator.backSetUrl('WEB-OPEN-HELP', faqURL);
        InternetBankingActions.navigateToWebTask('WEB-OPEN-FAQ');
    }
  }
  getHelpPanel() {
    if (UserManagementStore.isBusinessUser()) {
      return (
        <Panel
          iconClass={'icon-mail'}
          panelHeading={[LostCardHeader]}
          panelBody={[businessLostCardContent]}
        />
      );
    } else {
      if (
        !UserManagementStore.isNominatedUser() &&
        envConfig.isVulnerableCustomersEnabled
      ) {
        return (
          <Panel
            iconClass={['icon-vc-handshake', 'icon-mail', 'icon-creditCard']}
            panelHeading={[yourSupportHeader, LostCardHeader, feedbackHeader]}
            panelBody={[yourSupportContent, LostCardContent, feedbackContent]}
          />
        );
      } else {
        return (
          <Panel
            iconClass={['icon-mail', 'icon-creditCard']}
            panelHeading={[LostCardHeader, feedbackHeader]}
            panelBody={[LostCardContent, feedbackContent]}
          />
        );
      }
    }
  }

  getInfoCards() {
    return (
      <InfoCards
        infoCardsItems={this.getInfoCardsData()}
        content={this.props.content}
        cardClicked={this.decideContent}
        {...this.props}
      />
    );
  }

  getInfoCardsData() {
    const infoCardItems = [
      {
        id: ANY_QUESTION,
        cardName: this.props.content.AnyquestionTitle,
        cardContent: this.props.content.anyQuestionsContent,
        iconClass: 'c-panel__icon icon-help-questions',
        vmFaqCardLink: this.props.content.anyQuestionsFaqLink,
        vmFaqCardLinkSME: this.props.content.anyQuestionsFaqSMELink,
        svgId: null,
      },
      {
        id: CHAT,
        cardName: this.props.content.chat,
        cardContent: chatContent,
        iconClass: 'c-panel__icon icon-chat',
        svgId: null,
      },
      {
        id: CALL_CONTENT,
        cardName: this.props.content.callTitle,
        cardContent: callContent,
        iconClass: 'c-panel__icon icon-telephone',
        svgId: null,
      },
      {
        id: ABOUT_B,
        cardName: this.props.content.AboutBHead,
        cardContent: this.props.content.AboutBContent,
        iconClass: 'c-panel__icon icon-help-reminders',
        svgId: null,
      },
      {
        id: TERMS_AND_CONDITIONS,
        cardName: UserManagementStore.isSMEUser()
          ? authorisedUserTerm
          : termsCondition,
        cardContent: this.props.content.tncLine,
        iconClass: 'c-panel__icon icon-case',
        svgId: null,
      },
      {
        id: FINANCIAL_SERVICES,
        cardName: financialServices,
        cardContent: this.props.content.protectedLine,
        iconClass: 'c-panel__icon icon-fscs',
      },
    ];

    const secMsg = {
      id: SECURE_MESSAGE,
      cardName: this.props.content.messageTitle,
      cardContent: this.props.content.messageContent,
      iconClass: 'c-panel__icon u-vericle-middle',
      svgId: 'icon-envelope',
    };

    UserManagementStore.isSMEUser() && infoCardItems.splice(5, 1);
    !UserManagementStore.isBusinessUser() && infoCardItems.splice(1, 1);

    envConfig.isSecureMessageEnabled &&
      !UserManagementStore.isAdditionalUser() &&
      !UserManagementStore.isNominatedUser() &&
      infoCardItems.splice(3, 0, secMsg);

    return infoCardItems;
  }

  getModalBody() {
    return (
      <div>
        <p>{this.props.content.HelpPopupContent1}</p>
        <p>{this.props.content.HelpPopupContent2}</p>
      </div>
    );
  }

  getModalHeading() {
    return <strong>{this.props.content.PopupHeading}</strong>;
  }

  closed() {
    this.setState({ show: true });
  }

  continue() {
    this.setState({ showModal: false });
    window.open(this.props.content.BankUrl);
  }

  decideContent(i) {
    switch (i) {
      case ANY_QUESTION:
        this.setState({ component: ANY_QUESTION, show: false });
        AnalyticsUtil.analyticAction(
          config.analytics.analytics_experience_activity,
          config.analytics.analytics_event_method_interacted,
          config.analytics.analytics_action_any_questions,
          'click'
        );
        break;
      case CHAT:
        EgainActionCreator.getSamlToken();
        this.setState({
          showChatModal: true,
        });
        break;
      case SECURE_MESSAGE:
        InternetBankingActions.navigateToWebTask('WEB-SECURE-MESSAGE');
        break;
      case ABOUT_B:
        this.setState({ component: ABOUT_B, show: false });
        AnalyticsUtil.analyticAction(
          config.analytics.analytics_experience_activity,
          config.analytics.analytics_event_method_interacted,
          config.analytics.analytics_action_about_b,
          'click'
        );
        break;
      case TERMS_AND_CONDITIONS:
        this.setState({ component: TERMS_AND_CONDITIONS, show: false });
        AnalyticsUtil.analyticAction(
          config.analytics.analytics_experience_activity,
          config.analytics.analytics_event_method_interacted,
          config.analytics.analytics_action_terms_conditions,
          'click'
        );
        break;
      case FINANCIAL_SERVICES:
        this.setState({ showModal: true });
        break;
      default:
        this.setState({ component: ANY_QUESTION });
    }
  }

  initialiseCobrowse(e) {
    e.preventDefault();
    EgainUtils.initiateCobrowse();
  }

  initializeStaticContent() {
    TalkHeader = this.props.content.TalkHeader;
    EmailHeader = this.props.content.EmailHeader;
    feedbackHeader = this.props.content.feedbackHeader;
    LostCardHeader = this.props.content.LostCardHeader;
    yourSupportHeader = (
      <div>
        <p>
          <img
            alt=""
            src="../images/vm/vulnerable-customers/vc-handshake.png"
          />
          {this.props.content.yourSupportHeader}
        </p>
      </div>
    );
    callCardContent = !UserManagementStore.isSMEUser()
      ? this.props.content.callContent1
      : this.props.content.callContentBusiness;
    stolenCardContent = this.props.content.LostCardContent;
    // you can change the div or any html element here.s
    TalkContent = (
      <p dangerouslySetInnerHTML={{ __html: this.props.content.TalkData3 }} />
    );
    callContent = (
      <div>
        <p>{callCardContent}</p>
        <p>
          {this.props.content.callContent2}
          <a
            href="javascript:void(0)"
            className="c-panel__talk-Link"
            onClick={this.initialiseCobrowse}
          >
            {this.props.content.callContent3}
          </a>
          {this.props.content.callContent4}
        </p>
      </div>
    );
    chatContent = (
      <p dangerouslySetInnerHTML={{ __html: this.props.content.chatContent }} />
    );
    feedbackContent = (
      <div>
        <p>{this.props.content.feedbackContent}</p>
        <NavigationButton.Secondary
          labelText={this.props.content.sendFeedback}
          onClick={() =>
            window.open(
              `mailto:${this.props.content.FeedbackEmail}?subject=${this.props.content.EmailSubjectLine}`
            )
          }
        />
      </div>
    );

    // This is the content for Lost and stolen cards.
    LostCardContent = (
      <div>
        <span dangerouslySetInnerHTML={{ __html: stolenCardContent }} />
        {isBOrVMRetail() || isVMBusiness() ? (
          <a
            href={
              isBOrVMRetail()
                ? this.props.content.anyQuestionsFaqLink
                : this.props.content.anyQuestionsFaqSMELink
            }
            target="_blank"
            rel="noreferrer noopener"
          >
            <span>{this.props.content.LostCardContentFaq}</span>
          </a>
        ) : (
          <a
            href="javascript:;"
            onClick={() =>
              this.setState({ component: 'AnyQuestions', show: false })
            }
          >
            <span>{this.props.content.LostCardContentFaq}</span>
          </a>
        )}
        <span>{this.props.content.LostCardContentDot}</span>
      </div>
    );

    financialServices = (
      <span>
        <span>{this.props.content.financialServices}</span>&nbsp;
        <span className="icon icon-externallink">
          <span className="u-visually-hidden off-screen">external link</span>
        </span>
      </span>
    );

    termsCondition = (
      <span aria-label="Terms and Conditions">
        {this.props.content.TermsCondition}
      </span>
    );
    authorisedUserTerm = (
      <span aria-label="Authorised User Term">
        {this.props.content.AuthorisedUserTerm}
      </span>
    );
    businessLostCardContent = UserManagementStore.isCA() ? (
      <div>
        <p>{this.props.content.CALostCardContent}</p>
        <NavigationButton.Secondary
          labelText={this.props.content.manageDebitCardButton}
          onClick={() => {
            InternetBankingActions.navigateToWebTask(
              StringConstants.WEB_MANAGE_CARDS
            );
          }}
        />
      </div>
    ) : (
      <div>
        <p>{this.props.content.AULostCardContent}</p>
      </div>
    );

    yourSupportContent = (
      <div>
        <p>{this.props.content.yourSupportContent}</p>
        <NavigationButton.Secondary
          labelText="Find out more"
          onClick={NavigateToWebApps.navigateToBrochurewareYourSupportPage}
        />
        <NavigationButton.Primary
          labelText="Your Support"
          onClick={() =>
            NavigateToWebApps.navigateToVulnerableCustomersWebAppPage('HELP')
          }
        />
      </div>
    );
  }

  modalFooter() {
    return (
      <div className="button-group">
        <button
          className="c-btn c-modal__button c-btn--secondary"
          onClick={() => this.setState({ showModal: false })}
        >
          {this.props.content.cancelButtonText}
        </button>
        <button
          className="c-btn c-modal__button c-btn--default"
          onClick={this.continue}
        >
          {this.props.content.continueButtonText}
        </button>
      </div>
    );
  }

  retryButton() {
    UserManagementActionCreator.getUserDetails();
  }

  onHideChatModal() {
    this.setState({ showChatModal: false });
  }

  render() {
    const { content } = this.props;
    const { show, showModal, showChatModal } = this.state;
    return (
      <BioCatchContext context={HELP_CONTEXT}>
        {UserManagementStore.isCaDetailsUndefined() ? (
          <NonBCustomerError
            headerContent={content.HelpPageHeading}
            buttonName2={
              content.triggerDashboardViewController_NoEligibleAccounts_ButtonTitle
            }
            bodyContent1={content.helpPageError}
            bodyContent2=""
            handleButtonClick2={this.retryButton}
            headerFlag
            hideButton1
            componentName
            page
          />
        ) : (
          <div>
            <Helmet title="Help" />
            {/* the show flag decides whether to show the help page or its other child pages*/}
            {show ? (
              <div className="page page-help bow layout">
                <div className="layout__inner">
                  <div
                    id="site-main"
                    className="container"
                    role="main"
                    tabIndex="-1"
                  >
                    <div className="row">
                      <div className="col-md1-24">
                        <div className="c-step-header">
                          <h2 className="c-step-header__title">
                            {this.props.content.HelpPageHeading}
                          </h2>
                        </div>

                        <div className="row">
                          {/* the getinfocards gets the infocards on this page */}
                          <section className="col-md1-16 col-lg1-18">
                            {this.getInfoCards()}
                          </section>

                          <aside
                            id="site-sidebar"
                            className="col-md1-8 col-lg1-6"
                            tabIndex="-1"
                          >
                            {this.getHelpPanel()}
                          </aside>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div>{this.getComponent()}</div>
            )}
            <PatternLibModalComponent
              show={showModal}
              onHide={() => this.setState({ showModal: false })}
              bsSize={'medium'}
              modalHeading={this.getModalHeading()}
              modalBody={this.getModalBody()}
              modalFooter={this.modalFooter()}
              customClass={'c-modal'}
            />
            {showChatModal && (
              <GenericModal
                titleText={content.eGainChatModelHeader}
                onConfirm={this.onChatClick}
                isOpen={showChatModal}
                onClose={this.onHideChatModal}
                confirmButtonText={content.eGainChatModelButtonText}
                isCentred
              >
                <p>{content.eGainChatModelText}</p>
              </GenericModal>
            )}
          </div>
        )}
      </BioCatchContext>
    );
  }
}

HelpHomeComponent.propTypes = {
  content: PropTypes.object,
};

HelpHomeComponent.propTypes = {
  content: {},
};

export default RequiresAuthenticatedUser(HelpHomeComponent);
export { HelpHomeComponent };
